import CountryISOCodes from './CountryISOCodes';

export default countryCode => CountryISOCodes[countryCode];
